import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const SELECTS = [
  ['contact_outcome', 'Contact Outcome', 'contact_outcomes'], ['current_status', 'Current Status', 'current_statuses'],
  ['timesheet', 'Timesheet', 'timesheet_options'], ['certificate_upload', 'Certificate', 'certificate_upload_options'],
  ['case_management_type', 'Case Mgmt Type', 'case_management_types'], ['exit_outcome', 'Exit Outcome', 'exit_outcomes'],
  ['abawd_status', 'ABAWD', 'abawd_statuses'],
];
const TEXTS = [
  ['state_id_number', 'State ID', 'text'], ['employment_goal', 'Employment Goal', 'text'], ['barriers', 'Barriers (comma separated)', 'text'],
  ['certification_start_date', 'Cert Period Start', 'date'], ['certification_end_date', 'Cert Period End', 'date'],
];

// Saved periods look like "2026-09-15 - 2027-03-15" (older ones use "to")
const certPart = (r, i) => (String(r.certification_period || '').match(/\d{4}-\d{2}-\d{2}/g) || [])[i] || '';
const initialText = (r, f) => {
  if (f === 'barriers') return Array.isArray(r.barriers) ? r.barriers.join(', ') : r.barriers || '';
  if (f === 'certification_start_date') return r.certification_start_date || certPart(r, 0);
  if (f === 'certification_end_date') return r.certification_end_date || certPart(r, 1);
  return r[f] || '';
};

const TextField = ({ field, label, type, record, onSave, saving, disabled }) => {
  const [value, setValue] = useState(initialText(record, field));
  useEffect(() => setValue(initialText(record, field)), [record, field]);
  const commit = () => { if (value.trim() && value.trim() !== initialText(record, field)) onSave(field, value.trim()); };
  return (
    <div className="space-y-1">
      <Label className="text-xs">{label}</Label>
      <Input type={type} value={value} disabled={disabled || saving} className="h-8 text-xs" data-testid={`flag-field-${field}`}
        onChange={(e) => setValue(e.target.value)} onBlur={commit} onKeyDown={(e) => e.key === 'Enter' && e.currentTarget.blur()} />
    </div>
  );
};

export const FlagReviewFields = ({ record, options, onSave, savingField, disabled }) => (
  <div className="grid grid-cols-2 md:grid-cols-3 gap-3" data-testid="flag-review-fields">
    {SELECTS.map(([field, label, opt]) => (
      <div key={field} className="space-y-1">
        <Label className="text-xs flex items-center gap-1">{label}{savingField === field && <Loader2 className="h-3 w-3 animate-spin" />}</Label>
        <Select value={record[field] || ''} onValueChange={(v) => onSave(field, v)} disabled={disabled || savingField === field}>
          <SelectTrigger className="h-8 text-xs" data-testid={`flag-field-${field}`}><SelectValue placeholder="Select..." /></SelectTrigger>
          <SelectContent>
            {[...new Set([...(options?.[opt] || []), ...(record[field] ? [record[field]] : [])])].map((o) => <SelectItem key={o} value={o} className="text-xs">{o}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
    ))}
    {TEXTS.map(([field, label, type]) => (
      <TextField key={field} field={field} label={label} type={type} record={record} onSave={onSave} saving={savingField === field} disabled={disabled} />
    ))}
  </div>
);
